import {
  exportListDateFilterActive,
  type ExportListFilters,
} from "@/domain/export/filterExportJobs";
import { isoDateToUnixEnd, isoDateToUnixStart } from "@/utils/format/isoDate";

export function buildExportListApiParams(
  page: number,
  pageSize: number,
  filters: ExportListFilters,
): Record<string, unknown> {
  const params: Record<string, unknown> = { page, page_size: pageSize };
  if (filters.status !== "all") params.status = filters.status;
  if (exportListDateFilterActive(filters)) {
    const from = isoDateToUnixStart(filters.dateFrom);
    const to = isoDateToUnixEnd(filters.dateTo);
    if (from != null) params.created_from = from;
    if (to != null) params.created_to = to;
  }
  return params;
}
